import React from 'react';
import { motion } from 'framer-motion';
import { TeamMember } from '../data/team';

interface TeamMemberCardProps {
  member: TeamMember;
  index: number;
}

export const TeamMemberCard: React.FC<TeamMemberCardProps> = ({ member, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col h-full"
    >
      <div className="aspect-[4/5] w-full overflow-hidden bg-zinc-100">
        <img
          src={member.image}
          alt={member.name}
          className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-6 flex-1 flex flex-col">
        <h3 className="text-xl font-bold text-zinc-900 mb-4">{member.name}</h3>
        <p className="text-zinc-600 text-sm leading-relaxed flex-1">
          {member.bio}
        </p>
      </div>
    </motion.div>
  );
};
